import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ImpactMetrics from './components/ImpactMetrics';
import Features from './components/Features';
import UseCases from './components/UseCases';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FluidFormPreview from './pages/FluidFormPreview';
import WhatsAppPreview from './pages/WhatsAppPreview';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">FluidForm - Multimodal AI-powered Data Capture</title>
        <meta name="description" content="Schema-first conversational forms with built-in AI validation, multi-modal inputs, and intelligent follow-ups. Deploy across web, Slack, WhatsApp, and more." data-id="element-3" />
        <meta property="og:title" content="FluidForm - Multimodal AI-powered Data Capture" data-id="element-4" />
        <meta property="og:description" content="Schema-first conversational forms with built-in AI validation, multi-modal inputs, and intelligent follow-ups." data-id="element-5" />
        <meta name="twitter:title" content="FluidForm - Multimodal AI-powered Data Capture" data-id="element-6" />
        <meta name="twitter:description" content="Schema-first conversational forms with built-in AI validation, multi-modal inputs, and intelligent follow-ups." data-id="element-7" />
      </Helmet>
      <BrowserRouter data-id="element-8">
        <Routes data-id="element-9">
          <Route path="/terms" element={<TermsOfUse data-id="element-11" />} data-id="element-10" />
          <Route path="/privacy" element={<PrivacyPolicy data-id="element-13" />} data-id="element-12" />
          <Route path="/preview" element={<FluidFormPreview data-id="element-15" />} data-id="element-14" />
          <Route path="/whatsapp-preview" element={<WhatsAppPreview data-id="element-17" />} data-id="element-16" />
          <Route path="/" element={<div className="w-full min-h-screen font-sans" data-id="element-19">
                <Navbar data-id="element-20" />
                <Hero data-id="element-21" />
                <ImpactMetrics data-id="element-22" />
                <Features data-id="element-23" />
                <UseCases data-id="element-24" />
                <Pricing data-id="element-25" />
                <FAQ data-id="element-26" />
                <CTA data-id="element-27" />
                <Footer data-id="element-28" />
              </div>} data-id="element-18" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}